<template>
  <div>
    <div class="container-xl mx-auto flex h-screen w-full relative">
      <div
        class="sideNav hidden lg:flex lg:flex-col lg:justify-between h-full bg-blue py-3 px-2 min-h-screen"
      >
        <!-- --SIDE NAV-- -->
        <SideNav :navigation="navigation" />
        <Sos @openOverlay="overLay" />
      </div>
      <!-- --TOP NAV-- -->

      <div
        v-show="showBg"
        class="w-full flex flex-col bg-white relative overflow-auto"
      >
        <TopNav @openOverlay="overLay" :navigation="navigation" />
        <div v-if="showBg" class="h-screen w-f-full relative lg:ml-40 lg:mr-10">
          <slot />
        </div>
      </div>
    </div>
    <SosSlider :overLay="overLay" :animateOverlay="animateOverlay" />
  </div>
</template>

<script>
import SideNav from "@/components/layout/SideNav.vue";
import TopNav from "@/components/layout/TopNav.vue";
import SosSlider from "@/components/SosSlider.vue";
import Sos from "@/components/layout/Sos.vue";
import dash from "@/assets/images/Category.svg";
import eve from "@/assets/images/Document.svg";
import vid from "@/assets/images/Video.svg";
import set from "@/assets/images/Setting.svg";
import disc from "@/assets/images/Discovery.svg";
import rep from "@/assets/images/Document-1.svg";
// require('vue2-animate/dist/vue2-animate.min.css')
import { mapActions } from "vuex";

export default {
  components: { SideNav, TopNav, Sos, SosSlider },
  // CBox,
  data() {
    return {
      isOpen: false,
      animateOverlay: false,
      showBg: true,
      navigation: [
        {
          name: "Dashboard",
          icon: dash,
          to: "/dashboard"
        },
        {
          name: "Events",
          icon: eve,
          to: "/events"
        },
        {
          name: "Navigations",
          icon: disc,
          to: "/navigations"
        },
        {
          name: "Report & Logs",
          icon: rep,
          to: "/report"
        },
        {
          name: "Media Records",
          icon: vid,
          to: "/records"
        },
        {
          name: "Settings",
          icon: set,
          to: "/settings"
        }
      ]
    };
  },
  methods: {
    openNav() {
      return (this.navOpen = !this.navOpen);
    },
    overLay() {
      this.animateOverlay = !this.animateOverlay;
    },
    ...mapActions({
      GetSOS: "sos/GetSOS",
      getPredictions: "events/getPredictions"
    })
  },
  created() {
    this.GetSOS();
    this.getPredictions();
  }
};
</script>

<style lang="scss">
.sideNav {
  transition: width 0.6s cubic-bezier(0.25, 0.45, 0.45, 0.95);
  width: 6.2rem;
  z-index: 111;
  position: absolute;
  display: block;

  &:hover {
    width: 15%;
    @media (max-width: 1024px) {
      width: 22%;
    }

    .logo {
      display: block;
    }
  }
}
.btn-col {
  background: #00b1da;
}
</style>
